import { render } from "./ListUnincorporated.vue?vue&type=template&id=1a541a26&scoped=true"
import script from "./ListUnincorporated.vue?vue&type=script&lang=js"
export * from "./ListUnincorporated.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a541a26"]])

export default __exports__